<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <span class="itemHeading"> TARGET DETAILS</span>
          <v-spacer></v-spacer>
          <!-- <v-flex text-end align-self-center>
            <v-btn color="#005f32" rounded outlined class="mb-4" @click="addTargets = true">
              <span style="font-family: kumbhRegular;">Add Targets</span>
            </v-btn>
            <v-divider vertical class="mx-2" style="background-color: black; width: 1px; height:37px;">
            </v-divider>

            <v-btn color="#005f32" rounded outlined class="mb-4" @click="uploadTargets = true">
              <span style="font-family: kumbhRegular">Upload Targets</span>
            </v-btn>
          </v-flex> -->
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span style="font-family: kumbhRegular; font-size: 14px">*Select the options to filter the
                  results</span>
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2 pt-lg-0 pt-md-0 pt-sm-0 pt-2>
                <v-select clearable v-model="financialYear" :items="financialYears" item-text="name" item-value="name"
                  label="Financial Year" required outlined dense hide-details></v-select>
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2 pt-lg-0 pt-md-0 pt-sm-0 pt-2>
                <v-select clearable v-model="status" :items="tragetStatusArray" item-text="name" item-value="name"
                  label="Target Status" required outlined dense hide-details></v-select>
              </v-flex>
              <v-flex v-if="false" xl3 lg3 md3 sm6 xs12 pr-2 pt-lg-0 pt-md-0 pt-sm-2 pt-2>
                <v-select clearable v-model="isVerified" :items="isVerifiedArray" item-text="name" item-value="value"
                  label="Verification Status" required outlined dense hide-details></v-select>
              </v-flex>
              <v-flex v-if="false" xl3 lg3 md3 sm6 xs12 align-self-center pt-lg-0 pt-md-0 pt-sm-2 pt-2>
                <v-btn color="#005f32" dark block @click="verifyallTargets = true">
                  <v-icon small left> mdi-shield-check</v-icon> <span style="font-family: kumbhRegular">Verify All
                    Targets</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start px-4 v-if="targetArray.length > 0">
          <v-layout wrap justify-center>
            <v-flex>
              <v-card outlined elevation="1" class="pa-0">
                <v-layout wrap justify-start pt-5>
                  <v-flex xs12 sm12>
                    <apexchart type="pie" height="400px" width="400px" style="font-size: 6px" :options="chartOptions"
                      :series="series"></apexchart>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs11 sm11 md11 lg12 xl12 text-left pa-7 pl-11 v-for="(target) in targetArray"
                    :key="target.financialYear">
                    <v-layout wrap justify-space-between>
                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Financial Year
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.financialYear }}</span>
                      </v-flex>

                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Total Targets
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.totalTargetCount }}</span>
                      </v-flex>

                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Met Count
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.metCount }}</span>
                      </v-flex>

                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Not Met Count
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.notMetCount }}</span>
                      </v-flex>

                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Delayed Met Count
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.delayedMetCount }}</span>
                      </v-flex>

                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Total Score
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.totalScore }}</span>
                      </v-flex>

                      <v-flex class="text-left pa-2" style="flex: 1 0 auto; max-width: 14%; min-width: 110px;">
                        <span style="font-family: kumbhRegular; font-size: 15px; font-weight: bold; white-space: nowrap;">
                          Total Weightage
                        </span>
                        <br>
                        <span style="font-size: 15px;">{{ target.totalWeightage }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>

            </v-flex>
          </v-layout>
          <v-flex xs12 pt-3>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th style="
                    font-size: 15px;
                    color: #ffffff;
                    font-family: kumbhRegular;
                
                  " class="text-left">
                      SL.NO

                    </th>
                    <th style="
                    font-size: 15px;
                    color: #ffffff;
                    font-family: kumbhRegular;
                     
                  " :style="{
                    'width':
                      $vuetify.breakpoint.name == 'xs' ? '0px' :
                        $vuetify.breakpoint.name == 'sm' ? '0px' :
                          $vuetify.breakpoint.name == 'md' ? '300px' : '400px'
                  }" class="text-left">
                      Target

                    </th>
                    <th style="
                      font-size: 15px;
                      color: #ffffff;
                      font-family: kumbhRegular;
                      white-space: nowrap; /* Prevents text from wrapping */
                      overflow: hidden;    /* Ensures content does not overflow */
                      text-overflow: ellipsis; /* Adds ellipsis if content overflows */
                    " class="text-left">
                      Target Date
                    </th>

                    <th style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      " class="text-left">
                      Weightage

                    </th>
                    <th style="
                    font-size: 15px;
                    color: #ffffff;
                    font-family: kumbhRegular;
                  " class="text-left">
                      Rating Received
                    </th>

                    <th style="
                    font-size: 15px;
                    color: #ffffff;
                    font-family: kumbhRegular;
                  " class="text-left">
                      Target Status
                    </th>


                    <th v-if="false" style="
              font-size: 15px;
              color: #ffffff;
              font-family: kumbhRegular;
            " class="text-left">
                      Verification Status
                    </th>
                    <th v-if="false" style="
              font-size: 15px;
              color: #ffffff;
              font-family: kumbhRegular;
            " class="text-left">
                      Cancel Target
                    </th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <template v-for="(target) in targetArray">
                    <tr class=" text-left align-center" style="cursor:pointer;" v-for="(item, i) in target.targets"
                      :key="item._id" @click="redirectToViewPage(item)">
                      <!-- <td>
                        <span v-if="item.employeeId" class="" style="font-family: kumbhMedium">{{ item.employeeId }}</span>
                      </td>
                      <td >
                        <span v-if="item.employeeName" class="" style="font-family: kumbhMedium; cursor: pointer">
                         {{ item.employeeName }}
                        </span>
                      </td> -->
                      <td>
                        <span style="font-family: kumbhMedium;">{{ i + 1 }}</span>
                      </td>
                      <td style="text-align:left">
                        <span v-if="item.Targets" class="" style="font-family: kumbhMedium; cursor: pointer; white-space: pre-wrap;">{{ item.Targets.trim() }}</span>
                      </td>

                      <td>
                        <span v-if="item.TargetDate" style="
                            font-family: kumbhMedium;
                            display: inline-block; /* Ensures proper alignment */
                            white-space: nowrap; /* Prevents wrapping */
                            overflow: hidden; /* Ensures content stays within bounds */
                            text-overflow: ellipsis; /* Adds ellipsis if content is too long */
                            max-width: 150px; /* Adjust as needed for your table */
                          ">
                          {{ formatDate(item.TargetDate) }}
                        </span>
                      </td>
                      <td>
                        <span v-if="item.weightage" class="" style="font-family: kumbhMedium">{{ item.weightage
                        }}</span>
                      </td>
                      <td>
                        <span class="" style="font-family: kumbhMedium" :style="{ color: !item.isApprove && item.targetStatus !== 'Not Met' ? '#E65100' : '' }">{{ item.isApprove ? item.targetScore : (item.targetStatus !== 'Not Met' ? 'Under Review' : '-') }}</span>
                      </td>

                      <td>
                        <span
                          v-if="item.targetStatus"
                          style="font-family: kumbhMedium; color: #005f32; text-transform: uppercase;"
                        >
                          {{ item.targetStatus }}
                        </span>
                        <span
                          v-else
                          style="font-family: kumbhMedium; color: #005f32; text-transform: uppercase;"
                        >
                          -----
                        </span>
                      </td>

                      <td v-if="false">
                        <v-layout wrap>
                          <v-flex xs12 align-self-center text-left>

                            <v-btn v-if="false && !item.isVerified" small dark outlined color="#005f32"
                              @click.stop="openVerifyTargetDialog(item)" title="Add">
                              <v-icon small left> mdi-shield-check</v-icon>
                              Verify Target
                            </v-btn>
                            <span v-if="item.isVerified"
                              style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">
                              Verified
                            </span>
                          </v-flex>
                        </v-layout>
                      </td>
                      <td v-if="false">
                        <v-layout wrap>
                          <v-flex xs12 align-self-center text-left>

                            <v-btn v-if="!item.isVerified" small dark outlined color="error"
                              @click.stop="openCancelTargetDialog(item)" title="Cancel Target">
                              <v-icon small left>mdi-cancel</v-icon>
                              Cancel Target
                            </v-btn>
                            <span v-if="item.isVerified"
                              style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">
                              Verified
                            </span>
                            <!-- <span v-if="item.isCancelled"
                              style="font-family: kumbhMedium;color:red;text-transform:uppercase;">
                              Cancelled
                            </span> -->
                          </v-flex>
                        </v-layout>
                      </td>

                      <!-- <td>
                        <v-layout wrap>
                          <v-flex xs12 align-self-center text-left>
                            <span v-if="item.isVerified"
                              style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">
                              Verfied
                            </span>
                            <span v-if="!item.isVerified"
                            style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">
                            Not Verified
                          </span>

                          </v-flex>
                        </v-layout>
                      </td> -->


                      <!-- <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left>

                          <v-btn v-if="!item.isVerified" small dark outlined color="#005f32"
                            @click="openVerifyTargetDialog(item)" title="Add">
                            <v-icon small left> mdi-shield-check</v-icon>
                            Verify Target
                          </v-btn>
                          <span v-if="item.isVerified"
                            style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">
                            Verified
                          </span>

                        </v-flex>
                      </v-layout>
                    </td> -->
                      <!-- <td   class="text-right">
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-right pa-2>
                          <router-link
                            :to="`/Targets/viewTarget?targetId=${item._id}&financialYear=${financialYear}&TargetSheetId=${TargetSheetId}`">
                            <v-icon title="View" color="#005f32">mdi-eye</v-icon>
                          </router-link>

                        </v-flex>
                      </v-layout>
                    </td> -->
                      <!-- <td  class="text-right" v-if="item.isVerified=='true'">
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-right pr-10 style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">

                          Verified


                        </v-flex>
                      </v-layout>
                    </td> -->



                      <!-- <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left pa-1>
                          <v-btn v-if="!item.tragetStatus && item.isVerified" small dark outlined color="orange"
                            @click="openStatusTargetDialog(item)" title="Add">
                            <v-icon small left>mdi-alert-circle</v-icon>
                            Change Status
                          </v-btn>
                          <span style="font-family: kumbhMedium;color:#005f32;text-transform:uppercase;">
                            {{ item.tragetStatus }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </td> -->
                      <!-- <td v-if="item.tragetStatus">
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left pa-1 style="font-family: kumbhMedium;color:#005f32;">
                          {{ item.tragetStatus }}
                        </v-flex>
                      </v-layout>
                    </td> -->

                      <!-- <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center>
                          <v-btn v-if="canEditTargets && !item.isVerified" small dark outlined color="primary" @click="editItem(item)"
                            title="Add">
                            <v-icon small left>mdi-pencil</v-icon>
                            Edit
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td> -->
                      <!-- <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center>
                          <v-btn v-if="!item.isVerified" small dark outlined color="error"
                            @click="openDeleteDialog(item)" title="Add">
                            <v-icon small left>mdi-delete</v-icon>
                            Delete
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td> -->
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Data found!</span>
          </v-flex>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages" :total-visible="7"
            v-model="currentPage" color="#005f32"></v-pagination>
        </div>
      </v-flex>
    </v-layout>





    <!-- add targets manually -->
    <v-dialog persistent v-model="addTargets" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Target Details</span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="addTargets = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-select v-model="financialYear" :items="financialYears" label="Financial Year" required outlined dense
                  hide-details></v-select>
              </v-flex>
              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="targetDate1" label="Target Date" readonly outlined hide-details dense
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker color="#005f32" v-model="targetDate1" :allowed-dates="allowedDates"
                    :picker-date.sync="pickerDateString" scrollable></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-text-field v-model="targetWeightage" label="Target Weightage" required hide-details outlined
                  type="number" dense></v-text-field>

              </v-flex>
              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-textarea v-model="target" label="Target" required hide-details outlined dense></v-textarea>
              </v-flex>

              <v-flex xs12 text-end pt-3 pa-2>
                <v-btn @click="addTarget()" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Add Target </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- edit targets manually -->
    <v-dialog persistent v-model="editdialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Edit Target Details</span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="editdialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-text-field readonly v-model="financialYear" label="Financial Year" required hide-details outlined
                  dense></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="editingitem.TargetDate" label="Target Date" readonly outlined hide-details
                      dense v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker color="#005f32" v-model="targetDate" :allowed-dates="allowedDates" scrollable
                    @input="updateTargetDate"></v-date-picker>
                </v-menu>

              </v-flex>

              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-text-field v-model="editingitem.weightage" label="Target Weightage" required hide-details outlined
                  type="number" dense></v-text-field>

              </v-flex>
              <v-flex xs12 sm12 align-self-center text-left pa-2>
                <v-textarea v-model="editingitem.Targets" label="Target" required hide-details outlined
                  dense></v-textarea>
              </v-flex>

              <v-flex xs12 text-end pt-3 pa-2>
                <v-btn @click="edit()" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Edit Target </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showDialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Target Details
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="showDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-text class="pa-6" style="text-align:justify">
            {{ dialogContent }}
          </v-card-text>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- verify  targets -->
    <v-dialog persistent v-model="verifyTargets" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Target Verification
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="verifyTargets = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px">Are you sure you want to verify this
                  target?</span>
              </v-flex>

              <v-flex xs12 align-self-center text-right pt-3>
                <v-btn @click="verifyTarget()" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Verify Target </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- verify  all targets -->
    <v-dialog persistent v-model="verifyallTargets" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Target Verification
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="verifyallTargets = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px">Are you sure you want to verify all
                  targets ?</span>
              </v-flex>

              <v-flex xs12 align-self-center text-right pt-3>
                <v-btn @click="verifyAllTarget()" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Verify All Target </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- delete  targets -->
    <v-dialog persistent v-model="deletedialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Target Verification
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="deletedialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px">Are you sure you want to delete this
                  target?</span>
              </v-flex>

              <v-flex xs12 align-self-center text-right pt-3>
                <v-btn @click="confirmDelete" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Delete Target </span>
                </v-btn></v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="cancelTargetDialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Cancel Target
                </span>
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn icon color="white" text @click="cancelTargetDialog = false">
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pa-4></v-flex>
          <v-flex xs12>
            <v-layout wrap px-5 pb-8>
              <v-flex xs12 align-self-center text-left>
                <span class="kumbhBold" style="color: #000; font-size: 20px">
                  Are you sure you want to cancel this target?
                </span>
              </v-flex>
              <v-flex xs12 align-self-center text-left pt-3>
                <v-textarea v-model="cancelRemarks" label="Remarks (required)" outlined dense required
                  :rules="[v => !!v || 'Remarks are required']"></v-textarea>
              </v-flex>
              <v-flex xs12 align-self-center text-right pt-3>
                <v-btn @click="cancelTarget()" color="error">
                  <span class="kumbhBold" style="color: white"> Cancel Target </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    addTargets: false,
    verifyTargets: false,
    verifyallTargets: false,
    targetDate1: "",
    targetDate: "",
    // isTargetSheetVerified: "",
    uploadTargets: false,
    targetWeightage: "",
    target: "",
    pickerDate: null,
    pickerDateString: '',
    menu: false,
    menu1: false,
    statusTargets: false,
    itemToDelete: null,
    deletedialog: false,
    showDialog: false,
    dialogContent: "",
    additionalDetails: "",
    proofDescription: "",
    tragetStatus: "",
    proofFile: [],
    uploadedFileName: "",
    // uploadedFileNames: [],
    status: "", // Default to 'All'
    tragetStatusArray: [
      // Add 'All' option
      { _id: "0", name: "Met" },
      { _id: "1", name: "Not Met" },
      { _id: "2", name: "Delayed Met" },
    ],

    // Default to 'All'
    isVerified: "", // Default to 'All'
    isVerifiedArray: [
      { _id: "0", name: "All", value: "All" }, // Default option for no selection
      { _id: "1", name: "Verified", value: true },

    ],


    showsnackbar: false,
    ServerError: false,

    msg: null,
    pages: 0,
    pageCount: 1,
    appLoading: false,
    currentPage: 1,
    g: false,
    totalData: 0,
    financialYear: "",
    financialYear1: "",
    editingitem: "",
    editdialog: false,
    // filteredTragetStatusArray: [],
    financialYears: [],
    rules: {
      required: (value) => !!value || "Required.",
    },
    series: [],
    chartOptions: {
      chart: {
        type: "pie",
      },
      colors: ["#bf8d71", "#06402b"],
      dataLabels: {
        name: {
          fontSize: "22px",
        },
        value: {
          fontSize: "16px",
        },
      },
      labels: ["total Weightage", "Rating Received"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },


    // employeeId : this.$route.query.employeeId,
    employeeId: "",
    teamtargets: [],
    targetArray: [],
    // Cancel Target
    cancelTargetDialog: false,
    itemToCancel: null,
    cancelRemarks: "",
  }),

  mounted() {
    // this.getData();
    this.generateFinancialYears();
  },
  computed: {
    canEditTargets() {
      const userData = this.$store && this.$store.state ? this.$store.state.userData || {} : {};
      const candidates = [
        this.$store && this.$store.state && this.$store.state.userType,
        this.$store && this.$store.state && this.$store.state.role,
        userData.role,
        userData.roleName,
        userData.usertype,
        userData.name,
        localStorage.getItem("userType"),
        localStorage.getItem("role"),
      ];

      return candidates.some((value) => this.isSuperAdminRole(value));
    },
  },
  watch: {
    currentPage() {
      this.getData();
    },
    status() {
      this.getData();
    },
    isVerified() {
      this.getData();
    },

    financialYear() {
      this.getData();
    },
    pickerDate(newVal) {
      this.pickerDateString = newVal ? newVal.toISOString().substr(0, 10) : null;
    },
    targetDate(newVal) {
      console.log("Target Date Changed:", newVal);
      this.editingitem.TargetDate = this.formatDate(newVal);
    },
    editingitem: {
      handler(newVal) {
        console.log("Editing Item Updated:", newVal);
      },
      deep: true
    }

  },
  // created() {
  //   // Access $route after component initialization
  //   if (this.$route?.query?.employeeId) {
  //     this.employeeId = this.$route.query.employeeId;

  //   }
  // },
  methods: {

    handleFileUpload(event) {
      const file = event.target.files ? event.target.files[0] : null;

      if (!file) {
        this.msg = "No file selected!";
        this.showsnackbar = true;
        return;
      }

      // Allowed file types for Excel
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel" // .xls
      ];

      if (!allowedTypes.includes(file.type)) {
        this.msg = "Please upload only Excel files (.xls, .xlsx)";
        this.showsnackbar = true;
        return;
      }

      // Store the file and display the name
      this.targetSheet = file;
      this.uploadedFileName = file.name;
    },
    uploadTarget() {
      if (!this.financialYear) {
        this.msg = "Please choose a financial year.";
        this.showsnackbar = true;
        return;
      }
      if (!this.targetSheet) {
        this.msg = "Please upload the target sheet.";
        this.showsnackbar = true;
        return;
      }


      // Prepare form data for upload
      const formData = new FormData();
      formData.append("targetSheet", this.targetSheet);
      formData.append("financialYear", this.financialYear);

      axios({
        method: "POST",
        url: "/employee/targetSheet/upload/excel",
        data: formData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.uploadTargets = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          console.error(err);
          this.msg = "Failed to upload file!";
          this.showsnackbar = true;
        });
    },

    redirectToViewPage(item) {
      this.$router.push(
        `/Targets/viewTeamTargets?targetId=${item._id}&financialYear=${this.financialYear}&TargetSheetId=${item.TargetSheetId}&employeeId=${this.employeeId}`
      );
    },

    updateTargetDate(selectedDate) {
      if (selectedDate) {
        this.editingitem.TargetDate = this.formatDate1(selectedDate); // Format date on update
      } else {
        console.error("Invalid selected date from picker:", selectedDate);
      }
    },

    openVerifyTargetDialog(item) {
      this.item = item; // Set the selected item
      this.verifyTargets = true; // Open the dialog
    },
    openCancelTargetDialog(item) {
      this.itemToCancel = item;
      this.cancelTargetDialog = true;
    },
    cancelTarget() {
      if (!this.itemToCancel) return;
      if (!this.cancelRemarks) {
        this.msg = "Please enter remarks for cancellation.";
        this.showsnackbar = true;
        return;
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/verify/targetsheet/target/cancel",
        data: {
          financialYear: this.itemToCancel.financialYear,
          employeeId: this.$route.query.employeeId,
          targetSheetId: this.itemToCancel.TargetSheetId,
          targetId: this.itemToCancel._id,
          remarks: this.cancelRemarks, 
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cancelTargetDialog = false;
          this.cancelRemarks = "";
          this.msg = response.data.msg || "Target cancelled successfully.";
          this.showsnackbar = true;
          this.getData();
        })
        .catch((err) => {
          this.appLoading = false;
          this.cancelTargetDialog = false;
          this.cancelRemarks = "";
          this.ServerError = true;
          this.msg = "Failed to cancel target!";
          this.showsnackbar = true;
          console.error(err);
        });
    },
    verifyTarget() {

      axios({
        method: "POST",
        url: "/verify/targetsheet/target",
        data: {
          financialYear: this.item.financialYear,
          employeeId: this.$route.query.employeeId,
          targetSheetId: this.item.TargetSheetId,
          targetId: this.item._id

        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.verifyTargets = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    verifyAllTarget() {
      const targetSheetId = this.targetArray[0]?.targetSheetId; // Assuming you want the first _id in the array

      if (!targetSheetId) {
        this.msg = "Target Sheet ID not found!";
        this.showsnackbar = true;
        return;
      }

      axios({
        method: "POST",
        url: "/verify/targetsheet/all/target",
        data: {
          employeeId: this.$route.query.employeeId,
          targetSheetId: targetSheetId, // Pass the _id here
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.verifyallTargets = false;
            this.getData();
          } else {
            this.msg = response.data.message;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    generateFinancialYears() {
      const startYear = 2000;
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();

      // If the current month is before April (0-based index), it's still the previous financial year
      const endYear = currentMonth < 3 ? currentYear : currentYear + 1;

      for (let year = startYear; year <= endYear; year++) {
        this.financialYears.push(`${year}-${year + 1}`);
      }

      // Set default financial year to the current financial year
      const defaultStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
      this.employeeId = this.$route.query.employeeId || this.employeeId;
      this.financialYear = this.$route.query.financialYear || `${defaultStartYear}-${defaultStartYear + 1}`;
    },

    allowedDates(date) {
      if (!this.financialYear) return false;

      const [startYear, endYear] = this.financialYear.split("-").map(Number);

      const startDate = new Date(`${startYear}-04-01`);
      const lastDayOfFebruary = new Date(endYear, 2, 0).getDate();
      const endDate = new Date(endYear, 1, lastDayOfFebruary, 23, 59, 59, 999);

      const selectedDate = new Date(date);

      return selectedDate >= startDate && selectedDate <= endDate;
    },
    addTarget() {
      if (!this.financialYear) {
        this.msg = "Please choose a financial year.";
        this.showsnackbar = true;
        return;
      }
      if (!this.targetDate1) {
        this.msg = "Please enter target date.";
        this.showsnackbar = true;
        return;
      }
      if (!this.targetWeightage) {
        this.msg = "Please enter target weightage.";
        this.showsnackbar = true;
        return;
      }

      if (!this.target) {
        this.msg = "Please enter target details.";
        this.showsnackbar = true;
        return;
      }
      this.appLoading = true;
      axios({
        url: "/employee/targetSheet/add",
        method: "POST",
        data: {
          //   employeeId: this.employee,
          financialYear: this.financialYear,
          targetWeightage: this.targetWeightage,
          targetDate: this.targetDate1,
          target: this.target,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.addTargets = false;

            this.targetWeightage = null;
            this.targetDate = null;
            this.target = null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
    openDialog(content) {
      this.dialogContent = content; // Set the content for the dialog
      this.showDialog = true; // Open the dialog
    },
    //VERSION 1
    // handleFileUpload(event) {
    //   const files = event.target.files;
    //   const allowedTypes = ["application/pdf"];

    //   // Validate file type and limit
    //   for (const file of files) {
    //     if (!allowedTypes.includes(file.type)) {
    //       this.msg = "Please upload only PDF files.";
    //       this.showsnackbar = true;
    //       return;
    //     }
    //     if (this.proofFile.length >= 3) {
    //       this.msg = "You can upload a maximum of 3 files.";
    //       this.showsnackbar = true;
    //       return;
    //     }
    //     this.proofFile.push(file);
    //     this.uploadedFileNames.push(file.name);
    //   }
    // },


    editItem(item) {
      if (!this.canEditTargets) {
        this.msg = "Only Super Admin can edit targets.";
        this.showsnackbar = true;
        return;
      }
      this.editingitem = {
        ...item,
        TargetDate: item.TargetDate ? this.formatDate1(item.TargetDate) : null, // Ensure valid date or null
      };
      this.targetDate = this.editingitem.TargetDate || null; // Initialize targetDate for v-date-picker
      this.editdialog = true;
    },
    edit() {
      if (!this.canEditTargets) {
        this.msg = "Only Super Admin can update targets.";
        this.showsnackbar = true;
        return;
      }
      // if (!this.editingitem.financialYear) {
      //   this.msg = "Please choose a financial year.";
      //   this.showsnackbar = true;
      //   return;
      // }
      if (!this.editingitem.TargetDate) {
        this.msg = "Please enter target date.";
        this.showsnackbar = true;
        return;
      }
      if (!this.editingitem.weightage) {
        this.msg = "Please enter target weightage.";
        this.showsnackbar = true;
        return;
      }

      if (!this.editingitem.Targets) {
        this.msg = "Please enter target details.";
        this.showsnackbar = true;
        return;
      }

      this.appLoading = true;
      var data = {};
      data["financialYear"] = this.$route.query.financialYear;
      data["targetDate"] = this.editingitem.TargetDate;
      data["targetWeightage"] = this.editingitem.weightage;
      data["target"] = this.editingitem.Targets;
      data["targetSheetId"] = this.$route.query.TargetSheetId;
      data["targetId"] = this.editingitem._id;
      axios({
        url: "/employee/targetSheet/edit",
        method: "Post",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    isSuperAdminRole(value) {
      const normalized = String(value || "")
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      return normalized === "superadmin";
    },
    // openStatusTargetDialog(item) {
    //   this.item = item; // Set the selected item
    //   const currentDate = new Date();
    //   const targetDate = new Date(item.TargetDate);

    //   // Filter options dynamically
    //   if (targetDate < currentDate) {
    //     this.filteredTragetStatusArray = this.tragetStatusArray.filter(
    //       (status) => status.name !== "Met"
    //     );
    //   } else {
    //     this.filteredTragetStatusArray = [...this.tragetStatusArray];
    //   }

    //   this.statusTargets = true; // Open the dialog
    // },
    // statusTarget() {
    //   if (!this.tragetStatus) {
    //     this.msg = "Please choose Target Status.";
    //     this.showsnackbar = true;
    //     return;
    //   }
    //   if (!this.additionalDetails) {
    //     this.msg = "Please enter additional details.";
    //     this.showsnackbar = true;
    //     return;
    //   }
    //   if (!this.proofDescription) {
    //     this.msg = "Please enter description.";
    //     this.showsnackbar = true;
    //     return;
    //   }
    //   if (!this.proofFile || this.proofFile.length === 0) {
    //     this.msg = "Please upload at least one proof file.";
    //     this.showsnackbar = true;
    //     return;
    //   }
    //   if (!this.item || !this.item._id) {
    //     this.msg = "Target ID is missing.";
    //     this.showsnackbar = true;
    //     return;
    //   }

    //   // Prepare form data for upload
    //   const formData = new FormData();
    //   formData.append("employeeId", localStorage.getItem("userid"));
    //   formData.append("targetId", this.item._id);
    //   formData.append("targetSheetId", this.$route.query.TargetSheetId);
    //   formData.append("tragetStatus", this.tragetStatus);
    //   formData.append("additionalDetails", this.additionalDetails);
    //   formData.append("proofDescription", this.proofDescription);
    //   // VERSION 1
    //   // this.proofFile.forEach((file, index) => {
    //   //   formData.append(`proofFile[${index}]`, file);
    //   // });

    //   //     VERSION2
    //   //     this.proofFile.forEach((file) => {
    //   //   formData.append('proofFile[]', file); // Same key for all files
    //   // });

    //   this.proofFile.forEach(file => {
    //     formData.append('proofFile', file); // Append each file as 'proofFile[]'
    //   });      // Create a single array for all files


    //   // const proofFileArray = [];
    //   //   this.proofFile.forEach((file) => {
    //   //     proofFileArray.push(file); // Collect files into an array
    //   //   });

    //   //   // Append the array as a single key
    //   //   formData.append("proofFile", JSON.stringify(proofFileArray));
    //   axios({
    //     method: "POST",
    //     url: "/employee/update/target/status",
    //     data: formData,
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status === true) {
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //         this.statusTargets = false;
    //         this.getData();
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       this.msg = "Failed to upload file!";
    //       this.showsnackbar = true;
    //     });
    // },
    // getData() {
    //   this.appLoading = true;
    //   const financialYearToPass = this.financialYear;
    //   axios({
    //     url: "/admin/reportingmanagers/employees/target/list",
    //     method: "post",
    //     data: {
    //       employeeId: this.$route.query.id,
    //       financialYear: financialYearToPass, 
    //       targetStatus: this.status,
    //       //   date: new Date(),
    //     },
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },

    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       this.teamtargets = response.data.data;
    //       // this.supportDocument = response.data.data.supportDocument;
    //       this.totalData = response.data.totalLength;
    //       this.pages = Math.ceil(this.totalData / response.data.limit);
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },

    getData() {
      this.appLoading = true;

      // Ensure the current financial year is always used
      const financialYearToPass = this.financialYear;

      axios({
        url: "/admin/reportingmanagers/employees/target/list",
        method: "post",
        data: {
          employeeId: this.$route.query.employeeId,
          financialYear: financialYearToPass, // Pass the selected or default financial year
          targetStatus: this.status,
          isVerified: this.isVerified,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          const allTargets = response.data.data.map((item) => {
            const calculatedTotalScore = Array.isArray(item.targets)
              ? item.targets.reduce(
                  (sum, t) =>
                    sum +
                    (t.isApprove
                      ? Number(
                          t.ratingReceived !== undefined &&
                            t.ratingReceived !== null
                            ? t.ratingReceived
                            : t.targetScore
                        ) || 0
                      : 0),
                  0
                )
              : Number(item.totalScore) || 0;

            return {
              financialYear: item.financialYear,
              metCount: item.metCount,
              notMetCount: item.notMetCount,
              delayedMetCount: item.delayedMetCount,
              totalWeightage: item.totalWeightage,
              totalScore: Number(calculatedTotalScore.toFixed(2)),
              totalTargetCount:
                item.totalTargetCount ||
                (item.targets ? item.targets.length : 0),
              targets: item.targets, // Nested targets for table display
            };
          });
          this.targetArray = allTargets;
          this.totalData = allTargets.length;

          // Set the series data for the pie chart
          const totalWeightage = allTargets.reduce(
            (acc, target) => acc + (target.totalWeightage || 0),
            0
          );
          const totalScore = allTargets.reduce(
            (acc, target) => acc + (target.totalScore || 0),
            0
          );


          this.series = [totalWeightage, totalScore];
          this.chartOptions.labels = ["Total Weightage", "Rating Received"];

          // Set default financial year if not already selected
          if (!this.financialYear && response.data.data.length > 0) {
            this.financialYear = response.data.data[0].financialYear;
          }
        })

        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error(err);
        });
    },
    openDeleteDialog(item) {
      if (!this.canEditTargets) {
        this.msg = "Only Super Admin can delete targets.";
        this.showsnackbar = true;
        return;
      }

      this.itemToDelete = item;
      this.deletedialog = true;
    },
    confirmDelete() {
      if (!this.canEditTargets) {
        this.msg = "Only Super Admin can delete targets.";
        this.showsnackbar = true;
        this.deletedialog = false;
        return;
      }

      if (this.itemToDelete) {
        this.deleteItem(this.itemToDelete);
      }
      this.deletedialog = false;
    },
    deleteItem(r) {
      if (!this.canEditTargets) {
        this.msg = "Only Super Admin can delete targets.";
        this.showsnackbar = true;
        return;
      }

      var data = {};
      data["targetId"] = r._id;
      data["targetSheetId"] = this.$route.query.TargetSheetId;
      axios({
        url: "/employee/target/delete",
        method: "post",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      const dt = new Date(item);
      const day = String(dt.getDate()).padStart(2, '0'); // Ensure 2-digit day
      const month = String(dt.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = dt.getFullYear();
      return `${day}-${month}-${year}`;
    },

    formatDate1(date) {
      if (!date) return null;
      const d = new Date(date);
      if (isNaN(d)) {
        console.error("Invalid date:", date);
        return null; // Return null if the date is invalid
      }
      return d.toISOString().substr(0, 10); // Format as YYYY-MM-DD
    }
  },
};
</script>
<style>
.tableHead {
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhMedium;
}
</style>
